import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Image from 'react-bootstrap/Image';
import LogoImg from '../../../Assets/Img/Logo.png';
import './NavBar.css';

function NavBar() {
    const [scrolled, setScrolled] = useState(false);
    // 네비바 열림 상태 관리
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // 링크 클릭 시 메뉴를 닫는 함수
    const handleToggle = () => setExpanded(false);

    return (
        <div className={`navbar-wrapper ${scrolled ? 'scrolled' : 'at-top'}`}>
            {/* expanded와 onToggle 속성 추가 */}
            <Navbar
                expand="lg"
                /* expanded 상태에 따라 클래스 동적 추가 */
                className={`custom-navbar ${expanded ? 'expanded' : ''}`}
                expanded={expanded}
                onToggle={(isOpen) => setExpanded(isOpen)}
            >
                <Container>
                    <Navbar.Brand as={Link} to="/" onClick={handleToggle}>
                        <Image src={LogoImg} className="logo-img" />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mx-auto text-center">
                            {/* 각 Nav.Link에 onClick={handleToggle} 추가 */}
                            <Nav.Link as={Link} to="/onpyeong" className="custom-nav-link" onClick={handleToggle}>온평 소개</Nav.Link>
                            <Nav.Link as={Link} to="/fields" className="custom-nav-link" onClick={handleToggle}>업무 분야</Nav.Link>
                            <Nav.Link as={Link} to="/profile" className="custom-nav-link" onClick={handleToggle}>변호사 프로필</Nav.Link>
                            <Nav.Link as={Link} to="/case" className="custom-nav-link" onClick={handleToggle}>성공 사례</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className="custom-nav-link" onClick={handleToggle}>상담 요청</Nav.Link>
                            <Nav.Link as={Link} to="/location" className="custom-nav-link" onClick={handleToggle}>오시는 길</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

export default NavBar;